import { requestZipActionTypes, downloadZipActionTypes } from './actions';

const initialState = {
  loading: false,
  error: false,
  requestId: '',
};

const handleRequestZipRequest = (state) => ({
  ...state,
  loading: true,
  error: false,
});

const handleRequestZipSuccess = (state, action) => ({
  ...state,
  requestId: action.requestId,
});

const handleDownloadZipSuccess = (state) => ({
  ...state,
  loading: false,
});

const handleDownloadZipError = (state, action) => ({
  ...state,
  loading: false,
  error: action.error,
});

export default (state = initialState, action) => {
  const handlers = {
    [requestZipActionTypes.request]: handleRequestZipRequest,
    [requestZipActionTypes.success]: handleRequestZipSuccess,
    [downloadZipActionTypes.success]: handleDownloadZipSuccess,
    [downloadZipActionTypes.error]: handleDownloadZipError,
  };

  return handlers[action.type]
    ? handlers[action.type](state, action)
    : state;
};
